const Social = () => {
    return (
        <div className="social">
            <h2>Socials</h2>

            {/* <a href = "mailto:utkarshuh16@gmail.com?subject = Feedback&body = Hello!" className="button">utkarshuh16@email.com</a> */}
            <a href="https://twitter.com/ft_utkarsh" className="button" target="_blank">Twitter</a>
            <a href="https://www.linkedin.com/in/utkarsh-hadgekar-9a0b411a5/" className="button" target="_blank">LinkedIn</a>
            <a href="https://github.com/utkarsh-1602" className="button" target="_blank">GitHub</a>
            <a href="https://student-communities.hashnode.dev/" className="button" target="_blank" ><span className="text"> Blogs</span></a>
        </div>
    );
}

export default Social;